import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormsModule } from '@angular/forms';
import { first } from 'rxjs/operators';

//import { UserService } from '../../../services/user.service';
import { CommonDataService } from '../../../services/common-data.service';

declare var $:any;
declare var iziToast:any;

declare var $:any;

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.css']
})
export class OrdersComponent implements OnInit {
  
  pageName = "My Orders";
  modelData: any;
  modelName = 'Order';
  modelId = '0';

  constructor(private router: Router, private formBuilder: FormBuilder, private _data: CommonDataService) { 

    let modelObject1 = new FormData();

    modelObject1.append('modelName', this.modelName);
    //modelObject1.append('objectName', 'businessDetails');
    //modelObject1.append('id', this.modelId);

    $('#loader').show();
    //lets get the model for this page
        this._data.getModelData(modelObject1) 
        .pipe(first())
        .subscribe(
          data => {
            console.log(data);
            this.modelData = data['queryData'];

          },
          error => {

            console.log(error);
            iziToast.success({
              title: 'Error!',
              position: 'topRight',
              icon: 'icon-circle-check',
              message: 'Failed to orders info.'
          });

          $('#loader').hide();

          },

          () => {
              $('#loader').hide();
          }
      );
   }

  ngOnInit() {

  	$('#initialise-page').trigger('click');
  }

}
